export class PatchIngestionPipelineInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "namespace",
            "baseName": "namespace",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableName",
            "baseName": "tableName",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceType",
            "baseName": "sourceType",
            "type": "IngestionSourceType",
            "format": ""
        },
        {
            "name": "s3SourceProperties",
            "baseName": "s3SourceProperties",
            "type": "S3SourceProperties",
            "format": ""
        },
        {
            "name": "gcsSourceProperties",
            "baseName": "gcsSourceProperties",
            "type": "GcsSourceProperties",
            "format": ""
        },
        {
            "name": "kafkaSourceProperties",
            "baseName": "kafkaSourceProperties",
            "type": "KafkaSourcePropertiesInput",
            "format": ""
        },
        {
            "name": "bucketFilesSourceProperties",
            "baseName": "bucketFilesSourceProperties",
            "type": "BucketFilesSourceProperties",
            "format": ""
        },
        {
            "name": "sinkType",
            "baseName": "sinkType",
            "type": "IngestionSinkType",
            "format": ""
        },
        {
            "name": "icebergSinkProperties",
            "baseName": "icebergSinkProperties",
            "type": "IcebergSinkProperties",
            "format": ""
        },
        {
            "name": "paimonSinkProperties",
            "baseName": "paimonSinkProperties",
            "type": "PaimonSinkProperties",
            "format": ""
        },
        {
            "name": "computeSize",
            "baseName": "computeSize",
            "type": "IngestionComputeSize",
            "format": ""
        },
        {
            "name": "maxParallelism",
            "baseName": "maxParallelism",
            "type": "number",
            "format": ""
        },
        {
            "name": "slotsPerTm",
            "baseName": "slotsPerTm",
            "type": "number",
            "format": ""
        },
        {
            "name": "initialTmCount",
            "baseName": "initialTmCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "maxTmCount",
            "baseName": "maxTmCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "catalogId",
            "baseName": "catalogId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "nativeStreamProperties",
            "baseName": "nativeStreamProperties",
            "type": "NativeStreamProperties",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PatchIngestionPipelineInput.attributeTypeMap;
    }
    constructor() {
    }
}
